import { ColumnDetails, ColumnType } from '../../../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { getExchangeContentControlExpressionTypeGridOptions } from '../../../../../../../utils/uiSettings/exchange/exchange-protection.values';

export enum Column {
  TEXT = 1,
  TYPE,
  MATCH_CASE,
  WHOLE_WORD,
}

export enum ColumnKeys {
  TEXT = 'text',
  TYPE = 'type',
  MATCH_CASE = 'matchCase',
  WHOLE_WORD = 'wholeWord',
}

export const GRID_COLUMNS = [Column.TEXT, Column.TYPE, Column.MATCH_CASE, Column.WHOLE_WORD];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.TEXT,
      key: ColumnKeys.TEXT,
      columnName: translateFn('Text'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.TYPE,
      key: ColumnKeys.TYPE,
      columnName: translateFn('Type'),
      type: ColumnType.EDITABLE_SELECT,
      values: getExchangeContentControlExpressionTypeGridOptions(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.MATCH_CASE,
      key: ColumnKeys.MATCH_CASE,
      columnName: translateFn('Match case'),
      type: ColumnType.CHECKBOX,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.WHOLE_WORD,
      key: ColumnKeys.WHOLE_WORD,
      columnName: translateFn('Whole word'),
      type: ColumnType.CHECKBOX,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
  ];
}
